/* Studio progressively enhances native Shopify links and forms. */
(() => {
  function init(root = document) {
    root.querySelectorAll('[data-product-list]').forEach(list => {
      if (list.dataset.enhanced) return;
      list.dataset.enhanced = 'true';
      const filters = list.querySelector('[data-filters]');
      if (!filters) return;
      const products = [...list.querySelectorAll('.product[data-category]')];
      if (!products.length) return;
      filters.hidden = false;
      const status = list.querySelector('[data-filter-status]');
      filters.querySelectorAll('[data-filter]').forEach(button => {
        if (button.dataset.filter !== 'all' && !products.some(p => p.dataset.category === button.dataset.filter)) button.hidden = true;
        button.addEventListener('click', () => {
          let count = 0;
          products.forEach(product => {
            const hidden = button.dataset.filter !== 'all' && product.dataset.category !== button.dataset.filter;
            product.hidden = hidden;
            if (product.parentElement.classList.contains('product-block')) product.parentElement.hidden = hidden;
            if (!hidden) count++;
          });
          filters.querySelectorAll('[data-filter]').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
          if (status) status.textContent = `${count} ${count === 1 ? 'piece' : 'pieces'}`;
        });
      });
    });
    root.querySelectorAll('[data-variant-picker]').forEach(select => {
      if (select.dataset.enhanced) return;
      select.dataset.enhanced = 'true';
      select.addEventListener('change', () => select.form.requestSubmit());
    });
  }
  // Keep a normal link as the fallback until Shopify's configured banner is ready.
  document.addEventListener('click', async event => {
    const link = event.target.closest('[data-cookie-preferences]');
    if (!link || typeof window.privacyBanner?.showPreferences !== 'function') return;
    event.preventDefault();
    try { await window.privacyBanner.showPreferences(); }
    catch { window.location.assign(link.href); }
  });
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:block:select', event => {
    const list = event.target.closest('[data-product-list]');
    list?.querySelector('[data-filter="all"]')?.click();
  });
})();
